/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaSourceResponse from './AqaSourceResponse';

/**
 * The AqaQualityDefinitionUpdateResponse model module.
 * @module model/AqaQualityDefinitionUpdateResponse
 * @version v0
 */
export default class AqaQualityDefinitionUpdateResponse {
  /**
   * Constructs a new <code>AqaQualityDefinitionUpdateResponse</code>.
   * @alias module:model/AqaQualityDefinitionUpdateResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQualityDefinitionUpdateResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQualityDefinitionUpdateResponse} obj Optional instance to populate.
   * @return {module:model/AqaQualityDefinitionUpdateResponse} The populated <code>AqaQualityDefinitionUpdateResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQualityDefinitionUpdateResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('aqdIdToUse'))
        obj.aqdIdToUse = ApiClient.convertToType(data['aqdIdToUse'], 'String');
      if (data.hasOwnProperty('sources'))
        obj.sources = ApiClient.convertToType(data['sources'], [AqaSourceResponse]);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaQualityDefinitionUpdateResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaQualityDefinitionUpdateResponse.prototype.message = undefined;

/**
 * @member {String} aqdIdToUse
 */
AqaQualityDefinitionUpdateResponse.prototype.aqdIdToUse = undefined;

/**
 * @member {Array.<module:model/AqaSourceResponse>} sources
 */
AqaQualityDefinitionUpdateResponse.prototype.sources = undefined;

/**
 * @member {Boolean} successful
 */
AqaQualityDefinitionUpdateResponse.prototype.successful = undefined;

